/** ebooking 微信内置浏览器 H5 OAuth 辅助 */

export function isWechatBrowser() {
    return typeof navigator !== 'undefined' && /MicroMessenger/i.test(navigator.userAgent);
}

/** 从 search 或 hash 查询串读取 code（兼容 hash 路由） */
export function getWechatOAuthCode() {
    if (typeof window === 'undefined') {
        return '';
    }
    const pick = (query) => {
        if (!query) {
            return '';
        }
        const raw = String(query).replace(/^\?/, '').split('#')[0];
        const params = new URLSearchParams(raw);
        const code = params.get('code');
        return code ? decodeURIComponent(code) : '';
    };
    let code = pick(window.location.search);
    if (code) {
        return code;
    }
    const hash = window.location.hash || '';
    if (hash.indexOf('?') >= 0) {
        code = pick(hash.substring(hash.indexOf('?')));
        if (code) {
            return code;
        }
    }
    const qs = window.location.href.split('#')[0].split('?')[1];
    return pick(qs ? '?' + qs : '');
}

export function hasWechatOAuthCode() {
    return isWechatBrowser() && !!getWechatOAuthCode();
}

/** 登录成功后去掉 code，避免刷新重复使用失效 code */
export function clearWechatOAuthCodeFromUrl() {
    if (typeof window === 'undefined' || !window.history || !window.history.replaceState) {
        return;
    }
    try {
        const url = new URL(window.location.href);
        url.searchParams.delete('code');
        url.searchParams.delete('state');
        let hash = url.hash || '';
        if (hash.indexOf('?') >= 0) {
            const qIdx = hash.indexOf('?');
            const path = hash.slice(0, qIdx);
            const hp = new URLSearchParams(hash.slice(qIdx + 1).split('#')[0]);
            hp.delete('code');
            hp.delete('state');
            const rest = hp.toString();
            hash = rest ? `${path}?${rest}` : path;
            url.hash = hash;
        }
        window.history.replaceState(null, '', url.pathname + url.search + url.hash);
    } catch (err) {
        /** 降级：不影响登录主流程 */
    }
}

/** 与 webh5 / 后端 C('WEIXIN').APPID 一致 */
export function getWechatAppId() {
    if (process.env.NODE_ENV === 'development') {
        return 'wx295360e8f4db8905';
    }
    if (typeof location !== 'undefined' && location.hostname === 'ebk.liuniu.cn') {
        return 'wx295360e8f4db8905';
    }
    return 'wx185dfedbc423fbed';
}

/** 统一 OAuth 中间页（与后端 C('WEIXIN_OAUTH').BRIDGE_URI 一致） */
export function getWechatOAuthBridgeUri() {
    if (process.env.NODE_ENV === 'development') {
        return 'https://admin.liuniu.cn/wx';
    }
    if (typeof location !== 'undefined' && location.hostname.includes('liuniu.cn')) {
        return 'https://admin.liuniu.cn/wx';
    }
    return 'https://17eu.cn/wx';
}

/** ebooking 默认回跳：站点根，由路由再进 /login */
export function getDefaultReturnUrl() {
    if (typeof location === 'undefined') {
        return '';
    }
    return location.origin + '/';
}

/** @deprecated 请使用 getWechatOAuthBridgeUri */
export function getWechatOAuthRedirectUri() {
    return getWechatOAuthBridgeUri();
}

export function buildWechatAuthorizeUrl(appId, returnUrl) {
    const r = returnUrl || getDefaultReturnUrl();
    const state = encodeURIComponent(JSON.stringify({ r, t: Date.now() }));
    const redirectUri = encodeURIComponent(getWechatOAuthBridgeUri());
    return 'https://open.weixin.qq.com/connect/oauth2/authorize?appid=' + (appId || getWechatAppId()) +
        '&redirect_uri=' + redirectUri +
        '&response_type=code&scope=snsapi_userinfo&state=' + state +
        '&connect_redirect=1#wechat_redirect';
}



// WEBPACK FOOTER //
// ./src/utils/wechatOAuth.js